export const ONEUSER_SUBSCRIPTIONS_RESET_STATE = 'ONEUSER_SUBSCRIPTIONS_RESET_STATE';
export const ONEUSER_SUBSCRIPTIONS_CURRENT_ITEM = 'ONEUSER_SUBSCRIPTIONS_CURRENT_ITEM';
 
export const ONEUSER_SUBSCRIPTIONS_REQUEST_LOADING = 'ONEUSER_SUBSCRIPTIONS_REQUEST_LOADING';
export const ONEUSER_SUBSCRIPTIONS_REQUEST_SUCCESS = 'ONEUSER_SUBSCRIPTIONS_REQUEST_SUCCESS';
export const ONEUSER_SUBSCRIPTIONS_REQUEST_FAILED = 'ONEUSER_SUBSCRIPTIONS_REQUEST_FAILED';
 
export const ONEUSER_SUBSCRIPTIONS_CURRENT_ACTION = 'ONEUSER_SUBSCRIPTIONS_CURRENT_ACTION';
export const ONEUSER_SUBSCRIPTIONS_RESET_ACTION = 'ONEUSER_SUBSCRIPTIONS_RESET_ACTION';